<template>
	<footer>
		<div class="footer-element">
			<div class="row flex">
				<div class="columns column3">
					<div class="logo" aria-hidden="true" v-html="logo" />
				</div>
				<div class="columns column3">
					<h3>{{ $t('contact') }}</h3>
					<p>
						<a :href="`tel:${$phoneRaw(defaults[locale].website.phone)}`">
							<span>{{ defaults[locale].website.phone }}</span> </a
						><br />
						<a :href="`mailto:${defaults[locale].website.email}`"
							><span>{{ defaults[locale].website.email }}</span></a
						>
					</p>
					<social-media :socials="socials" />
				</div>
				<div class="columns column3">
					<h3>{{ $t('location') }}</h3>
					<p>
						<span>{{ defaults[locale].website.street }} {{ defaults[locale].website.number }}</span
						><br />
						<span>{{ defaults[locale].website.postalCode }} {{ defaults[locale].website.city }}</span
						><br />
						<span>{{ defaults[locale].website.country }}</span
						><br />
					</p>
				</div>
				<div class="columns column3">
					<h3>{{ $t('footerNavigate') }}</h3>
					<p class="footer-nav">
						<nuxt-link v-for="item in footermenu[locale]" :key="item.filename" :to="item.filename">
							{{ item.header }} <br />
						</nuxt-link>
					</p>
				</div>
			</div>
			<div class="divider">
				<div class="columns column12">
					<hr />
				</div>
			</div>
		</div>
		<div class="footer-element author">
			<div class="row">
				<div class="columns column12 align-center">
					<p>
						<a :href="$t('siteByUrl')" target="_blank" rel="noopener noreferrer"> Hotel Website Design </a>
						by:
						<a :href="$t('siteByUrl')" target="_blank">
							<img class="siteByLogo" :src="$t('siteByLogo')" loading="lazy" alt="Site by" />
							Porter
						</a>
					</p>
					<p>
						<span v-for="item in bottomfooter[locale]" :key="item.filename">
							<nuxt-link :to="item.filename">
								{{ item.header }}
							</nuxt-link>

							<span> | </span>
						</span>
						<a v-if="defaults[locale].cookieConsent.published" href="#" @click.prevent="openConsent"
							>{{ $t('consentOpen') }}
						</a>
					</p>
				</div>
			</div>
		</div>
	</footer>
</template>

<script setup>
import logo from '~/assets/images/logo.svg?raw';

const { data: footer } = await useWebsiteFetch('footermenu');
const { footermenu, bottomfooter } = footer.value;
const { locale } = useI18n();

const { defaults, socials, fetchDefaults } = useDefaults();
const { openConsent } = useCookieConsent();

await fetchDefaults();
</script>

<style lang="scss" scoped>
:deep(.logo svg) {
	fill: var(--color-silk);
}

h3 {
	color: var(--color-silk) !important;
}

.footer-element {
	background: var(--primary-background-color);
	color: #fff;
	padding: 75px 0 10px;
	font-size: 15px;
}

.footer-element hr {
	background: #f4f0e7;
}

.footer-element a {
	color: #fff;

	&:hover {
		color: var(--cta-color);
	}
}

.footer-element h3 {
	color: #fff;
	font-size: 30px;
}

.footer-element.author {
	padding: 10px 0;
	font-size: 12px;
}

.author .column12 {
	display: flex;
	flex-wrap: nowrap;
	justify-content: space-between;
}

.author img {
	max-width: 20px;
	margin: 0 1px 0 2px;
}

.footer-logo {
	max-width: 180px;
	margin: 0 0 30px;
}

:deep(.socials a) {
	place-content: unset;
}

@media (max-width: 920px) {
	.row {
		flex-flow: wrap;
	}

	.divider .columns {
		width: 90% !important;
		margin: auto;
	}

	.footer-element {
		text-align: center;

		.socials {
			place-content: center;
		}

		:deep(.socials a) {
			place-content: center;
		}
	}

	.footer-element .columns {
		margin: 20px auto;
		width: calc((100% / 12 * 6) - var(--gap) * 0.5);
	}

	.author .columns {
		margin: 0 auto;
		flex-flow: column-reverse wrap;
		align-items: center;
		text-align: center;
	}

	.author p {
		width: 100%;
		margin: 0 0 5px;
		text-align: center;
	}
}

@media (max-width: 680px) {
	.footer-element {
		text-align: center;
	}
}

@media (max-width: 480px) {
	.footer-element {
		text-align: center;
	}

	.footer-element .columns {
		width: 100%;
	}
}
</style>
